import { render, staticRenderFns } from "./site-configurator-modal.vue?vue&type=template&id=ddfe8c5e&scoped=true"
import script from "./site-configurator-modal.vue?vue&type=script&lang=js"
export * from "./site-configurator-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfe8c5e",
  null
  
)

export default component.exports